// DS: i5.4
import React from 'react';
import IconWrap from '../../IconWrap';
const FavStarFill = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.375 1a.625.625 0 0 0-.551.331L5.286 4.215l-3.241.505a.625.625 0 0 0-.503.441l-.44 1.493a.625.625 0 0 0 .147.607l2.36 2.477-.553 3.473a.625.625 0 0 0 .259.611l1.351.945c.203.141.47.15.682.022L8 13.18l2.656 1.611c.21.127.474.12.676-.018l1.37-.936a.625.625 0 0 0 .265-.618l-.575-3.48 2.355-2.473a.625.625 0 0 0 .145-.616l-.457-1.475a.625.625 0 0 0-.5-.432l-3.247-.507-1.513-2.9A.625.625 0 0 0 8.621 1H7.375Z"
    })));
};
FavStarFill.displayName = 'FavStarFill';
export default FavStarFill;

//# sourceMappingURL=FavStarFill.js.map